import makeStyles from "@mui/styles/makeStyles";

export const EventUseStyles = makeStyles((theme) => ({
  root: {
    margin: "20px",
  },
  frstRow: {
    height: "60px",
    borderRadius: "8px",
    padding: "12px",
    margin: "6px",
    boxShadow: "0px 0px 16px #00000014",
    backgroundColor: "white",

    "& .MuiTextField-root": {
      "& label": {
        lineHeight: ".9rem",
        color: "#ababab",
      },
      "& div": {
        "& fieldset": {
          border: "none",
        },
      },
    },
  },
  finalRow: {
    borderRadius: "8px",
    padding: "12px",
    margin: "6px",
    boxShadow: "0px 0px 16px #00000014",
    backgroundColor: "white",
    position: "relative",
  },
  addIconBox: {
    backgroundColor: "#464775",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    height: "40px",
    boxShadow: "0 5px 20px #0000000A",
  },
  btnGrp: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  btn: {
    backgroundColor: "#f45e2d",
    borderRadius: "4px",
    fontWeight: "500",
    fontSize: "17px",
    color: "#fff",
    cursor: "pointer",
    textAlign: "center",
    border: "1px solid",
    borderColor: theme.palette.primary.dark,
    padding: "6px 14px",
  },
  unactive: {
    padding: "10px",
    // marginTop: "24px",
    textAlign: "center",
    borderRadius: "10px",
    fontSize: "14px",
    cursor: "pointer",
    border: "1px solid #E4E8EE",
    backgroundColor: "white",
    margin: 5,
  },
  active: {
    padding: "10px",
    textAlign: "center",
    borderRadius: "10px",
    color: "white",
    // marginTop: "24px",
    fontSize: "14px",
    backgroundColor: "#5078E1",
    cursor: "pointer",
    margin: 5,
  },
  btnBox: {
    display: "flex",
    justifyContent: "end",
    marginBottom: "16px",
  },
  eventName: {
    color: "black",
    fontSize: "16px",
    marginBottom: "12px",
    fontWeight: 600,
  },
  eventTitle: {
    color: "black",
    fontSize: "24px",
    marginBottom: "12px",
    fontWeight: 600,
    textAlign: "center",
  },
  eventImg: {
    borderRadius: "6px",
  },
  errorMsg: {
    color: "red",
    fontSize: "12px",
    paddingLeft: "12px",
  },
}));
